import React from 'react';
import Lottie from "react-lottie";
import * as AppStore from "../../redux/app";
import {useDispatch} from "react-redux";
import shine from "../../assets/animations/shine.json";

const DailyTasksDone = ({item, index, type}) => {
    const dispatch = useDispatch();
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: shine,
        isClickToPauseDisabled: true,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <div key={Math.random().toString()} className={`tasks-taskItem ${type === 'daily' ? 'tasks-dailyStyle' : ''}`}>
            {item?.icon && <img alt="Jace Tapp" src={item?.icon} className="tasks-icon" />}
            {!item?.icon && <p className="tasks-bigNumber">{index + 1}</p>}
            <div className="tasks-textContainer">
                <p className="tasks-taskTitle lineNumber1">{item.title}</p>
                {(item?.task_type !== 'app_section' && item?.task_type !== 'modal') && <p className="tasks-taskDescription lineNumber1">{item.url}</p>}
            </div>
            <div className={`tasks-status relative ${type === 'daily' ? 'tasks-customPaddingDaily' : ''}`}>
                <p className="text-white fs12 font-bold lineNumber1">{item.is_done ? 'Well Done!' : 'Do & Earn'}</p>
                <div className="absolute w100 h100 r0">
                    <Lottie
                        isClickToPauseDisabled={true}
                        options={defaultOptions}
                        height="100%"
                        width="100%"
                        eventListeners={[
                            {
                                eventName: 'complete',
                                callback: () => dispatch(AppStore.actions.setShowCelebrate(false)),
                            },
                        ]}/>
                </div>
            </div>
        </div>
    )
};

export default DailyTasksDone;
